var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 6.0025C7.72625 6.02 8.4 5.64375 8.7675 5.01375C9.135 4.3925 9.135 3.61375 8.7675 2.9925C8.4 2.37125 7.72625 1.98625 7 2.00375C5.915 2.03 5.04 2.91375 5.04 4.0075C5.04 5.10125 5.90625 5.985 7 6.01125V6.0025ZM3.00125 10.8237C3.00125 10.8237 10.9987 10.8238 10.9987 10.8413V8.715C10.9987 7.56875 8.33 7 7 7C5.67 7 3.00125 7.56875 3.00125 8.715V10.8237ZM7 14C3.1325 14 0 10.8675 0 7C0 3.1325 3.1325 0 7 0C10.8675 0 14 3.1325 14 7C14 10.8675 10.8675 14 7 14Z",
    fill: "url(#paint0_linear_25084_66371)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25084_66371",
    x1: 9.42634,
    y1: 14,
    x2: 4.57366,
    y2: 2.78866e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE3876",
    stopOpacity: 0.519832
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D030DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.cb8dc48a0fceb53750f14cc3310d482d.svg";
export { ForwardRef as ReactComponent };